import React from 'react';

import './page.css';
import LoadingPage from '../../components/loading/LoadingPage';
import MainTitle from '../../components/page/main-title/MainTitle';

import PageDados from './PageDados';
import PageAcesso from './PageAcesso';
import PageTreino from './PageTreino';
import PageEndereco from './PageEndereco';
import PageTermos from './PageTermos';
import PagePolitica from './PagePolitica';

const DADOS = 1;
const ACESSO = 2;
const TREINO = 3;
const ENDERECO = 4;
const TERMOS = 5;
const POLITICA = 6;

class Page extends React.Component{
  constructor (props){
    super(props);

    this.state = {
      isLoading: false,
      perfil: (props.location.state && props.location.state.page && props.location.state.page === "mudar_treino") ? TREINO : DADOS
    }
    console.log(this.state);
    this.changeData = this.changeData.bind(this);
  }

  getPage() {
    switch(this.state.perfil){
      case DADOS:
        return <PageDados />;
      break;
      case ACESSO:
        return <PageAcesso />;
      break;
      case TREINO:
        return <PageTreino />;
      break;
      case ENDERECO:
        return <PageEndereco />
      break;
      case TERMOS:
        return <PageTermos />
      break;
      case POLITICA:
        return <PagePolitica />
      break;
    }
  }

  changeData(e,tipo) {
    this.setState({
      perfil: tipo
    });

    e.preventDefault();
  }

  render() {
    let wrapper = this.state.isLoading ? <LoadingPage /> : this.getPage();

    return (
      <div className="page-dashboard page-content" >
        <div className="container">
          <div className="container-box">
            <div className="container-box--inner">
              <MainTitle title="Meu perfil"></MainTitle>
                <div>
                  <div className='wrapper-buttons-mensagens'>
                    <a
                      onClick={(e) => this.changeData(e, DADOS)}
                      className={`${(this.state.perfil === DADOS ? 'ativo' : '')} button-mensagem`}
                      href="#"
                    >Meus dados</a>
                    <a
                      onClick={(e) => this.changeData(e, ACESSO)}
                      className={`${(this.state.perfil === ACESSO ? 'ativo' : '')} button-mensagem`}
                      href="#"
                    >Mudar dados de acesso</a>
                    <a
                      onClick={(e) => this.changeData(e, TREINO)}
                      className={`${(this.state.perfil === TREINO ? 'ativo' : '')} button-mensagem`}
                      href="#"
                    >Mudar treino</a>
                    <a
                      onClick={(e) => this.changeData(e, ENDERECO)}
                      className={`${(this.state.perfil === ENDERECO ? 'ativo' : '')} button-mensagem`}
                      href="#"
                    >Meu endereço</a>
                  <div>
                    <a href='#'
                      onClick={(e) => this.changeData(e, TERMOS)}
                      className='bt-termos'
                    >Termos de uso</a>
                    <a href='#'
                      onClick={(e) => this.changeData(e, POLITICA)}
                      className='bt-termos'
                    >Política de privacidade</a>
                  </div>
                  </div>
                  <div className="listagem listagem-mensagens">
                    {wrapper}
                  </div>
                  <div className='clear'></div>
                </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Page;



// WEBPACK FOOTER //
// ./src/classes/perfil/Page.js